/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimReportResult
 */
export interface TimReportResult {
    /**
     * 
     */
    level?: string;
    /**
     * 
     */
    next_level_probability?: string;
}

/**
 * Check if a given object implements the TimReportResult interface.
 */
export function instanceOfTimReportResult(value: object): value is TimReportResult {
    return true;
}

export function TimReportResultFromJSON(json: any): TimReportResult {
    return TimReportResultFromJSONTyped(json, false);
}

export function TimReportResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimReportResult {
    if (json == null) {
        return json;
    }
    return {
        
        'level': json['level'] == null ? undefined : json['level'],
        'next_level_probability': json['next_level_probability'] == null ? undefined : json['next_level_probability'],
    };
}

export function TimReportResultToJSON(json: any): TimReportResult {
    return TimReportResultToJSONTyped(json, false);
}

export function TimReportResultToJSONTyped(value?: TimReportResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'level': value['level'],
        'next_level_probability': value['next_level_probability'],
    };
}

